import React, { Children, useEffect, useState } from "react";

//ANT DESIGN IMPORTS
import { Row, Typography, Col, Card, Breadcrumb, Tooltip } from "antd";
import { InfoCircleOutlined } from '@ant-design/icons';
import { Link } from "react-router-dom";

//PROJECT IMPORTS
import appLabel from "../../../config/appLabel";

const { Text, Title } = Typography;

function TopContent(props) {
  const { pageTitle, tooltipInfo, createPageTitle } = props;

  return (
    <Col>
      <Row style={{ marginBottom: 0, marginTop: 0 }}>
        <Title level={3} style={{ margin: 0 }}>
          {pageTitle}&nbsp;{tooltipInfo && <Tooltip title={tooltipInfo}><InfoCircleOutlined style={{ cursor: "pointer" }} /></Tooltip>}
        </Title>
      </Row>
      <Row style={{ marginBottom: 0, marginTop: 0 }}>
        <Text level={3} style={{ margin: 0 }}>
          {createPageTitle}
        </Text>
      </Row>
    </Col>
  );
}

export default TopContent;
